import React, { useState } from 'react';

// 保养小贴士数据
const maintenanceTips = [
  {
    id: 'anti-oxidation',
    title: '防氧化',
    tips: [
      '避免长时间接触水和汗液',
      '不佩戴时应将手链擦干并存放在干燥处',
      '避免接触化妆品、香水等化学物品',
      '定期使用专业的保养液清洁'
    ],
    image: 'https://via.placeholder.com/400x300/FFB3BA/ffffff?text=防氧化'
  },
  {
    id: 'cleaning',
    title: '清洗',
    tips: [
      '使用温水和温和的肥皂水清洗',
      '用软布轻轻擦拭，避免刮伤表面',
      '避免使用刷子或粗糙的布料',
      '清洗后用软布擦干，放在通风处晾干'
    ],
    image: 'https://via.placeholder.com/400x300/BAFFC9/ffffff?text=清洗'
  },
  {
    id: 'storage',
    title: '存放',
    tips: [
      '将手链放在首饰盒或专用袋中',
      '避免与其他首饰混放，防止刮伤',
      '存放在干燥、阴凉的地方',
      '定期检查手链的状态'
    ],
    image: 'https://via.placeholder.com/400x300/BAE1FF/ffffff?text=存放'
  },
  {
    id: 'daily-care',
    title: '日常护理',
    tips: [
      '避免剧烈运动时佩戴',
      '避免长时间暴露在阳光下',
      '定期检查扣子和线材的状态',
      '发现问题及时修复'
    ],
    image: 'https://via.placeholder.com/400x300/FFFFBA/ffffff?text=日常护理'
  },
  {
    id: 'special-handling',
    title: '特殊处理',
    tips: [
      '水晶手链避免接触高温',
      '珍珠手链避免接触酸性物质',
      '金属首饰避免接触盐水',
      '贵重手链建议定期到专业机构保养'
    ],
    image: 'https://via.placeholder.com/400x300/E2BAFF/ffffff?text=特殊处理'
  }
];

const MaintenanceTips = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredTips, setFilteredTips] = useState(maintenanceTips);

  // 处理搜索
  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    
    if (term === '') {
      setFilteredTips(maintenanceTips);
    } else {
      const filtered = maintenanceTips.filter(tip => 
        tip.title.includes(term) || 
        tip.tips.some(t => t.includes(term))
      );
      setFilteredTips(filtered);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-indigo-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-indigo-800">
          手链保养小贴士
        </h1>
        
        {/* 搜索框 */}
        <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 mb-8 border border-purple-100">
          <div className="relative">
            <input
              type="text"
              placeholder="按关键词搜索保养小贴士..."
              value={searchTerm}
              onChange={handleSearch}
              className="w-full px-4 py-3 pl-12 rounded-lg border border-purple-200 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
            />
            <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
              🔍
            </div>
          </div>
        </div>

        {/* 保养小贴士列表 */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {filteredTips.map((tip) => (
            <div key={tip.id} className="bg-white rounded-xl shadow-lg overflow-hidden border border-purple-100">
              {/* 保养图片 */}
              <div className="h-48 overflow-hidden">
                <img
                  src={tip.image}
                  alt={tip.title}
                  className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                />
              </div>
              
              {/* 保养信息 */}
              <div className="p-6">
                <h2 className="text-xl font-semibold mb-4 text-indigo-700">
                  {tip.title}
                </h2>
                <ul className="space-y-2">
                  {tip.tips.map((t, index) => (
                    <li key={index} className="flex items-start gap-2">
                      <div className="mt-1 text-purple-600">•</div>
                      <p className="text-gray-600">{t}</p>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        {/* 搜索结果为空时的提示 */}
        {filteredTips.length === 0 && (
          <div className="bg-white rounded-xl shadow-lg p-8 text-center border border-purple-100 mt-6">
            <p className="text-gray-600">未找到匹配的保养小贴士</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaintenanceTips;